import PropTypes from 'prop-types'
import { useState, useEffect, useContext } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import { CarritoContext } from '../context/carritoContext'
import { adjuntoBuilder } from '../reutilizables/upload/adjuntoBuilder'
import { Upload } from '../reutilizables/upload/Upload'
import * as archivoAdjuntoService from '../servicios/archivoAdjuntoService'
import * as mensajesService from '../servicios/mensajesService'
import * as presupuestosItemService from '../servicios/presupuestosItemService'
import * as presupuestosService from '../servicios/presupuestosService'
import * as publicacionesService from '../servicios/publicacionesService'
import styles from './PresupuestoForm.module.css'
import PresupuestoFormItem from './PresupuestoFormItem'
import PresupuestoFormItemList from './PresupuestoFormItemList'

const ID_ADJUNTOS_PRESUPUESTOS = 9

const PresupuestoForm = ({
  idPresupuesto,
  presupuesto: presupuestoProp,
  usuarioId,
  handleEstado,
  canAdministrate
}) => {
  const context = useContext(CarritoContext)
  const [presupuesto, setPresupuesto] = useState({
    idPresupuesto: presupuestoProp.idPresupuesto,
    descripcion: presupuestoProp.descripcion,
    fechaEntrega: presupuestoProp.fechaEntrega,
    fechaValidez: presupuestoProp.fechaValidez,
    idEstado: presupuestoProp.idEstado
  })

  const [mediosPago, setMediosPago] = useState([])
  const [presupuestoItems, setPresupuestoItems] = useState([])
  const [totalPresupuesto, setTotalPresupuesto] = useState(0)
  const [confirmado, setConfirmado] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [nombreAdjunto, setNombreAdjunto] = useState('')

  const { fechaEntrega, fechaValidez } = presupuesto

  const fetchAdjunto = async () => {
    const { data } = await archivoAdjuntoService.buscarUltimoAdjunto(
      presupuestoProp.idVendedor || usuarioId,
      ID_ADJUNTOS_PRESUPUESTOS,
      idPresupuesto
    )
    setNombreAdjunto(data?.nombre || '')
  }

  const abrirAdjunto = async () => {
    try {
      const { data } = await archivoAdjuntoService.buscarArchivo(
        presupuestoProp.idVendedor || usuarioId,
        ID_ADJUNTOS_PRESUPUESTOS,
        idPresupuesto
      )
      if (data?.adjunto?.archivo) {
        const { dataAdjunto, adjunto } = data
        const blob = Uint8Array.from(atob(dataAdjunto), (c) => c.charCodeAt(0))

        await adjuntoBuilder(blob, adjunto, adjunto?.archivo || 'adjunto')
      } else {
        toast.warn('No se encontraron archivos adjuntos.')
      }
    } catch {
      toast.error('Error al obtener el adjunto.')
    }
  }

  useEffect(() => {
    presupuestoProp.idPresupuesto && fetchAdjunto()
  }, [presupuestoProp.idPresupuesto, nombreAdjunto])

  useEffect(() => {
    if (presupuestoProp.idPresupuesto) {
      setPresupuesto(presupuestoProp)
      obtenerItems(idPresupuesto)
      obtenerMediosPago(presupuestoProp.idPublicacion, idPresupuesto)
    }
  }, [presupuestoProp])

  const obtenerMediosPago = async (idPublicacion, idPresupuesto) => {
    const { data: mediosPago } = await publicacionesService.BuscarMedioPagoPublicacion(
      idPublicacion,
      idPresupuesto
    )
    setMediosPago(mediosPago)
  }

  const obtenerItems = async (idPresupuesto) => {
    const { data: presupuestoItemTemp } =
      await presupuestosItemService.buscarItemPorId(idPresupuesto)
    setPresupuestoItems(presupuestoItemTemp)
    setTotalPresupuesto(
      presupuestoItemTemp.length > 0 ? presupuestoItemTemp[0].totalPresupuesto : 0
    )
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (
      presupuesto.descripcion !== '' &&
      presupuesto.fechaEntrega !== '' &&
      presupuesto.fechaValidez !== ''
    ) {
      setShowModal(true)
      setConfirmado(true)
    }
  }

  const updatePresupuestoItems = async (presupuestoItem) => {
    const { data: presupuestoItemsTemp } = await presupuestosItemService.buscarItemPorId(
      presupuestoItem.idPresupuesto
    )
    setPresupuestoItems(presupuestoItemsTemp)
    setTotalPresupuesto(presupuestoItemsTemp[0].totalPresupuesto)
  }

  const deleteItemList = async (presupuestoItem) => {
    const newItems = presupuestoItems.filter(
      (item) => item.idPresupuestoItem !== presupuestoItem
    )
    setPresupuestoItems(newItems)

    const deleteItem = {
      idPresupuesto: presupuesto.idPresupuesto,
      idPresupuestoItem: presupuestoItem
    }
    await presupuestosItemService.eliminar(deleteItem)

    const { data: presupuestoItemsTemp } = await presupuestosItemService.buscarItemPorId(
      presupuesto.idPresupuesto
    )
    setTotalPresupuesto(
      presupuestoItemsTemp.length > 0 ? presupuestoItemsTemp[0].totalPresupuesto : 0
    )
  }

  const handleClose = () => {
    setShowModal(false)
  }

  const onChange = (e) => {
    setPresupuesto({ ...presupuesto, [e.target.name]: e.target.value })
  }
  const onBlur = async () => {
    const presupuestoTemp = {
      idPresupuesto: presupuesto.idPresupuesto,
      descripcion: presupuesto.descripcion,
      fechaEntrega: presupuesto.fechaEntrega,
      fechaValidez: presupuesto.fechaValidez,
      idEstado: presupuesto.confirmar ? 1 : 0
    }
    await presupuestosService.actualizar(presupuestoTemp)
  }

  const onSave = async () => {
    const presupuestoTemp = {
      idPresupuesto: presupuesto.idPresupuesto,
      descripcion: presupuesto.descripcion,
      fechaEntrega: presupuesto.fechaEntrega,
      fechaValidez: presupuesto.fechaValidez,
      idEstado: presupuesto.confirmar ? 1 : 0
    }
    await presupuestosService.actualizar(presupuestoTemp)
    toast.success('La información fué actualizada.')
  }

  const onMedioChange = async (e) => {
    const presupuestoTemp = {
      idPresupuesto: presupuesto.idPresupuesto,
      descripcion: presupuesto.descripcion,
      fechaEntrega: presupuesto.fechaEntrega,
      fechaValidez: presupuesto.fechaValidez,
      idEstado: presupuesto.confirmar ? 1 : 0,
      idMedioPago: parseInt(e.target.value)
    }

    await presupuestosService.actualizar(presupuestoTemp)
  }

  const enviarComprador = async () => {
    setConfirmado(!confirmado ? true : false)
    setShowModal(false)
    handleEstado('Confirmado')

    const presupuestoTemp = {
      idPresupuesto: presupuesto.idPresupuesto,
      descripcion: presupuesto.descripcion,
      fechaEntrega: presupuesto.fechaEntrega,
      fechaValidez: presupuesto.fechaValidez,
      idEstado: confirmado ? 1 : 0
    }
    const mensaje = {
      idMensajePadre: null,
      idPublicacion: null,
      idPedidoItem: null,
      idPresupuesto: presupuesto.idPresupuesto,
      idUsuarioChat: presupuestoProp.idUsuario,
      idComprador: presupuestoProp.idUsuario,
      idVendedor: usuarioId,
      texto: '',
      privado: false,
      idMensajeTipo: 7
    }
    await mensajesService.insertar(mensaje)
    await presupuestosService.actualizar(presupuestoTemp)
    setPresupuesto((presupuestoProp.idEstado, presupuestoTemp.idEstado))
  }

  const setIdPresupuestoSel = (idPre) => {
    context.setIdPublicacionComprar(0)
    context.setIdPresupuestoComprar(idPre)
  }

  return (
    <>
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="row">
            <div className="cont-descripcion col">
              <p className="titulo-descripcion-detalle">Descripción:</p>
              <textarea
                name="descripcion"
                className="text-area"
                cols="35"
                rows="6"
                placeholder="Escribe aquí­ la descripción de tu presupuesto."
                value={presupuesto.descripcion}
                onChange={onChange}
                onBlur={onBlur}
                required
                disabled={!canAdministrate}
              ></textarea>
            </div>
          </div>
          <div className="row">
            <div className="cont-descripcion col">
              <p className="titulo-descripcion-detalle">Medios de Pago:</p>
              <div className="row">
                <div className="col">
                  {mediosPago
                    .filter((medioPago) => canAdministrate || medioPago.tienePresupuesto)
                    .map((medioPago) => (
                      <div key={medioPago.idMedioPago} className="row">
                        {canAdministrate && (
                          <div className="col-1">
                            <input
                              type="checkbox"
                              name={'mediopago'}
                              value={medioPago.idMedioPago}
                              onChange={onMedioChange}
                              defaultChecked={medioPago.tienePresupuesto ? 'checked' : ''}
                            />
                          </div>
                        )}
                        <div className="col">
                          <i
                            className={medioPago.icono}
                            style={{ marginRight: '5px' }}
                            aria-hidden="true"
                          />
                          {medioPago.nombre}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="cont-descripcion col">
              <p className="titulo-descripcion-detalle">Fecha Entrega:</p>
              <input
                name="fechaEntrega"
                type="date"
                value={fechaEntrega}
                onChange={onChange}
                onBlur={onBlur}
                required
                disabled={!canAdministrate}
              />
            </div>
          </div>

          <div className="row">
            <div className="cont-descripcion col">
              <p className="titulo-descripcion-detalle">Validez Presupuesto:</p>
              <input
                name="fechaValidez"
                type="date"
                value={fechaValidez}
                onChange={onChange}
                onBlur={onBlur}
                required
                disabled={!canAdministrate}
              />
            </div>
          </div>
        </div>

        {canAdministrate && (
          <div className="row">
            <div className="col-4"></div>
            <div className="col-4">
              {presupuesto.idEstado === 0 ? (
                <button type="submit" className="btn btn-preguntar">
                  Confirmar Presupuesto
                </button>
              ) : null}
            </div>
            <div className="col-4"></div>
          </div>
        )}
        <div>
          <p className="titulo-descripcion-detalle">
            Adjunto:
            {canAdministrate && (
              <Upload
                idDoc={presupuestoProp.idPresupuesto}
                idPerfil={usuarioId}
                idTipo={'9'}
                onCarga={() => setNombreAdjunto(null)}
              />
            )}
            {nombreAdjunto && (
              <span
                className={styles.archivo}
                onClick={abrirAdjunto}
                title="Abrir adjunto"
              >
                {nombreAdjunto}
              </span>
            )}
          </p>
        </div>
        {canAdministrate && (
          <Modal show={showModal} onHide={handleClose} size={'lg'} animation={false}>
            <Modal.Header closeButton>
              <Modal.Title>
                <h3>Confirmar Presupuesto</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Estás por confirmar tu presupuesto. Esta acción no se podrá deshacer y le
                avisaremos a tu comprador que el presupuesto ya está disponible para su
                pago.
              </p>
              ¿Estás seguro?
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-enviar" onClick={handleClose}>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-volver-comprar"
                onClick={enviarComprador}
              >
                Confirmar Presupuesto
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </form>
      {presupuestoItems.length > 0 && (
        <div>
          <p className="titulo-descripcion-detalle">
            <b>Detalle Presupuesto:</b>
          </p>
          <div className="row">
            <div className="col">
              <b>Item</b>
            </div>
            <div className="col text-right">
              <b>Cantidad</b>
            </div>
            <div className="col text-right">
              <b>Precio</b>
            </div>
            <div className="col">
              <b>Unidad Medida</b>
            </div>
            <div className="col text-right">
              <b>Total</b>
            </div>
            <div className="col text-right"></div>
          </div>
          <hr />
        </div>
      )}

      {presupuestoItems.map((item) => (
        <PresupuestoFormItemList
          key={item.idPresupuestoItem}
          item={item}
          idEstado={presupuestoProp.idEstado}
          onDelete={deleteItemList}
          canAdministrate={canAdministrate}
        />
      ))}
      {presupuestoItems.length > 0 && (
        <div className="row">
          <div className="col text-right">
            <b>
              <p className="mb-0">Total a pagar:</p>
              {totalPresupuesto}
            </b>
          </div>
        </div>
      )}
      {!canAdministrate && presupuesto.idEstado === 1 && (
        <Link
          to={'/compras'}
          className={styles.comprarAhoraBtn}
          onClick={() => setIdPresupuestoSel(presupuesto.idPresupuesto)}
        >
          Comprar Ahora
        </Link>
      )}
      {canAdministrate && presupuesto.idEstado === 0 ? (
        <>
          <PresupuestoFormItem
            idPresupuesto={presupuesto.idPresupuesto}
            onUpdate={updatePresupuestoItems}
          />
          <div className="row mt-2">
            <div className="col-4"></div>
            <div className="col-4">
              <button type="button" className="btn btn-preguntar" onClick={onSave}>
                Guardar Presupuesto
              </button>
            </div>
            <div className="col-4"></div>
          </div>
        </>
      ) : null}
    </>
  )
}

PresupuestoForm.propTypes = {
  presupuesto: PropTypes.shape({
    idPresupuesto: PropTypes.number.isRequired,
    descripcion: PropTypes.string.isRequired,
    fechaEntrega: PropTypes.string.isRequired,
    fechaValidez: PropTypes.string.isRequired,
    idEstado: PropTypes.number.isRequired,
    idPublicacion: PropTypes.number.isRequired
  }).isRequired,
  handleEstado: PropTypes.func.isRequired,
  usuarioId: PropTypes.number.isRequired
}

export default PresupuestoForm

PresupuestoForm.propTypes = {
  idPresupuesto: PropTypes.number.isRequired,
  presupuesto: PropTypes.shape({
    idPresupuesto: PropTypes.number.isRequired,
    descripcion: PropTypes.string.isRequired,
    fechaEntrega: PropTypes.string.isRequired,
    fechaValidez: PropTypes.string.isRequired,
    idEstado: PropTypes.number.isRequired,
    idPublicacion: PropTypes.number,
    idVendedor: PropTypes.number,
    idUsuario: PropTypes.number
  }).isRequired,
  usuarioId: PropTypes.number.isRequired,
  handleEstado: PropTypes.func.isRequired,
  canAdministrate: PropTypes.bool.isRequired
}
